import Spinner from "@/components/Spinner/Spinner.vue";
import { mapGetters } from "vuex";
import candidatureService from "@/services/candidature";
import { CANDIDATURE_MESSAGE } from "@/constants/variables";
import Utils from "@/mixins/Utils";
import SectionTitle from "@/components/SectionTitle/SectionTitle.vue";
import documentService from "@/services/document";
export default {
  data() {
    return {
      guid: this.$route.query.id || "",
      title: "",
      content: "",
      buttonLabel: "",
      buttonUrl: "",
      loadingCand: false,
      interested: this.$route.query.interested || 0,
      vitallianceTitle: '',
    };
  },
  mixins: [Utils],
  components: {
    Spinner,
    SectionTitle,
  },
  computed: {
    ...mapGetters({
      errorMessage: "errorMessage",
      loadingSpinner: "isLoading",
      successMessage: "successMessage",
    }),
  },
  async created() {
    if (this.guid) {
      this.loadingCand = true;

      await candidatureService
        .checkCandidatureInfo(this.guid, this.interested)
        .then((res) => {
          if (!res.success) {
            this.updateErrorContent(res.message);
          } else {
            switch (res.message) {
              case CANDIDATURE_MESSAGE.VIVIER_NOT_INTERESTED_BUTTON: {
                this.updateContent({
                  title: this.$t("vivier-not-interested-label"),
                  content: this.$t("vivier-not-interested-text"),
                  buttonLabel: this.$t("vivier-not-interested-button"),
                  buttonUrl: "vivier-not-interested-button",
                }, "vivier-not-interested-button");

                break;
              }

              case CANDIDATURE_MESSAGE.VIVIER_STILL_INTERESTED_TEXT: {
                this.updateContent({
                  title: this.$t("vivier-still-interested-label"),
                  content: this.$t("vivier-still-interested-text"),
                  buttonLabel: this.$t("vivier-still-interested-button"),
                  buttonUrl: "vivier-still-interested-button",
                }, "vivier-still-interested-button");
                break;
              }
              default: {
                this.loadingCand = false;
                break;
              }
            }
          }
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.updateErrorContent(err.response.data.message);
          } else {
            this.updateErrorContent(CANDIDATURE_MESSAGE.VIVIER_ERROR_CONTENT)
          }
        });
    }
  },
  methods: {
    getVitallianceTitle(value) {
      switch (value) {
        case 'vivier-not-interested-button': {
          this.vitallianceTitle = this.$t("vivier-not-interested-first-label");
          break;
        }
        case 'vivier-still-interested-button': {
          this.vitallianceTitle = this.$t("vivier-still-interested-first-label");
          break;
        }
        case 'vivier-unknown-error-button': {
          this.vitallianceTitle = this.$t("vivier-unknown-error-first-label");
          break;
        }
        case 'vivier-error-button': {
          this.vitallianceTitle = this.$t("vivier-error-first-label");
          break;
        }
      }



    },
    updateErrorContent(message) {
      switch (message) {
        case CANDIDATURE_MESSAGE.VIVIER_ERROR_CONTENT: {
          this.updateContent({
            title: this.$t("vivier-error-label"),
            content: this.$t("vivier-error-content"),
            buttonLabel: this.$t("vivier-error-button"),
            buttonUrl: "vivier-error-button",
          }, "vivier-error-button");
          break;
        }

        case CANDIDATURE_MESSAGE.VIVIER_UNKNOWN_ERROR_TEXT: {
          this.updateContent({
            title: this.$t("vivier-unknown-error-label"),
            content: this.$t("vivier-unknown-error-text"),
            buttonLabel: this.$t("vivier-unknown-error-button"),
            buttonUrl: "vivier-unknown-error-button",
          }, "vivier-unknown-error-button");
        }
        default: {
          this.updateContent({
            title: this.$t("vivier-error-label"),
            content: this.$t("vivier-error-content"),
            buttonLabel: this.$t("vivier-error-button"),
            buttonUrl: "vivier-error-button",
          });
          break;
        }
      }
    },

    updateContent(value, vitaTitleKeyword = "") {
      this.title = value.title;
      this.content = value.content;
      this.buttonLabel = value.buttonLabel;
      this.getVitallianceTitle(vitaTitleKeyword);
      this.getButtonUrl(value.buttonUrl);
    },
    getButtonUrl(keyword) {
      documentService
        .getComponentBykeyword({ keyword: keyword, isBackground: true })
        .then((res) => {
          this.loadingCand = false;
          if (res && res.components) {
            this.buttonValue = res.components[0].valueUrl;
          }
        })
        .catch((err) => {
          this.loadingCand = false;
        });
    },

    redirectToPostTulerUrl() {
      if (this.buttonValue) {
        window.open(this.buttonValue, "_blank");
      }
    },
  },
};
